export default "__VITE_ASSET__DUpSuc8U__"